import * as t from "io-ts";
import { createCargoEmissionsTypes } from "dora-contracts";

export const { cargoEmissionsResponseT } = createCargoEmissionsTypes({
  decimal: t.string,
  dateTime: t.string,
});

export const cargoEmissionsResponsesT = t.array(cargoEmissionsResponseT);

export type CargoEmissionsResponse = t.TypeOf<typeof cargoEmissionsResponseT>;
